
import React from "react";
import { ModalBody, Modal, Button, Image } from "react-bootstrap";
import { baseUrl } from "../../../../../utils";

const getDetails = (type)=>{
    let obj = {
        heading: 'AI Recommendation',
        description: 'Need assistance in whether a post is simply worthy or not? Try our latest AI-enabled Recommendation Score feature and display the posts likely to engage the most people.',
        url: baseUrl(`products/recommendation-popup.png`),
        isVideo: false
    }
    if(type == 2){
        obj = {
            heading: 'Sentiment Analysis',
            description: `Isn't it time-consuming to read long captions of posts to understand their nature? Try our sentiment analysis feature based on AI to know if the post is positive or negative with one look.`,
            url: baseUrl(`products/sentiment-popup-min.png`),
            isVideo: false
        }
    }else if(type == 3){
        obj = {
            heading: 'TruSense',
            description: `Try TruSense and and harness the power of AI with features like AI recommendation, Smart Curation, Visual Search, etc.`,
            url: baseUrl(`products/trusense-intro.mp4`),
            isVideo: true
        }
    }
    return obj;
}

class UpgradeAutoPilot extends React.Component{
    render(){
        const { show, handleClose, exploreSocialWall, type, hideUpgradeBtn } = this.props;
        const { heading, description, url, isVideo } = getDetails(type);
        return(
            <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <ModalBody className="p-3 socialwall-popup-body">
                    <div className="row align-itmes-center sw_theme">
                    <h2 className="font-weight-boldest w-100 text-center mt-0">{heading}</h2>
                     <p className="mb-3 text-dark text-center">{description}</p>
                        <div className="col-lg-12">
                            <div className="switch_image ugc-switch-video mb-3 w-100">
                               {!isVideo ? <Image className="img-fluid" src={url} alt='' /> :
                                  <video autoPlay id="audioTag" controls muted>
                                    <source src={url} type="video/mp4" />
                                  </video>}
                            </div>
                        </div>
                        <div className="col-lg-12">
                            {!hideUpgradeBtn ? <div className="switch_text_inner text-center">
                                <Button variant="primary" size="lg" onClick={exploreSocialWall} className={`btn-min-w mt-2`}> Upgrade Now </Button>
                            </div> : null}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}
export default UpgradeAutoPilot;